import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateSort'
})
export class DateSortPipe implements PipeTransform {
  transform(array: any[]): any[] {
    if (!array || array.length === 0) {
      return array;
    }

    return array.sort((a, b) => {
      if(a.expiration_date){
        const dateA = new Date(a.expiration_date);
        const dateB = new Date(b.expiration_date);
        return dateA.getTime() - dateB.getTime();
      } else if (a.requestTime){
        const dateA = new Date(a.requestDate + " " + a.requestTime);
        const dateB = new Date(b.requestDate + " " + b.requestTime);
        return dateA.getTime() - dateB.getTime();
      }
    });
  }
}
